import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { Modal } from "./Modal";
import { ModalButton } from "./styled/ModalButton";

export class ModalConfirm extends PureComponent {
    render() {
        return (
            <Modal
                isOpen={this.props.isOpen}
                onRequestClose={this.props.onRequestClose}
                contentLabel={
                    this.props.contentLabel || "Are you sure you want to make this change?"
                }
            >
                <ButtonContainer>
                    <ModalButton onClick={this.props.onConfirm} data-testid="confirm-button">
                        Confirm
                    </ModalButton>
                    <ModalButton inverted onClick={this.props.onRequestClose}>
                        Cancel
                    </ModalButton>
                </ButtonContainer>
            </Modal>
        );
    }
}

const ButtonContainer = styled.div`
    display: flex;
    flex-flow: row nowrap;

    button {
        margin-bottom: 0;
    }
`;

ModalConfirm.propTypes = {
    contentLabel: PropTypes.string,
    onConfirm: PropTypes.func,
    isOpen: PropTypes.bool,
    onRequestClose: PropTypes.func
};
